import { TFunction } from 'i18next';

const DOCUMENTS_VALUE_RE = /^(\d[\d,]*)\s+Documents$/i;

export function getBillingPricingFeatureLabel(
  featureId: number | undefined,
  fallback: string,
  t: TFunction
): string {
  if (featureId == null) {
    return fallback;
  }

  return t(`billing.pricing-features.${featureId}.name`, {
    defaultValue: fallback,
  });
}

export function getBillingPricingFeatureHelp(
  featureId: number | undefined,
  fallback: string,
  t: TFunction
): string {
  if (featureId == null || !fallback || fallback.trim() === '') {
    return fallback;
  }

  return t(`billing.pricing-features.${featureId}.help`, {
    defaultValue: fallback,
  });
}

export function formatBillingPricingFeatureValue(
  value: string | boolean | number,
  t: TFunction
): string | boolean | number {
  if (typeof value !== 'string') {
    return value;
  }

  if (value === 'Unlimited') {
    return t('billing.pricing-value.unlimited', { defaultValue: value });
  }

  const documentsMatch = value.match(DOCUMENTS_VALUE_RE);
  if (documentsMatch) {
    const count = documentsMatch[1].replace(/,/g, '');
    return t('billing.pricing-value.documents', {
      count,
      defaultValue: value,
    });
  }

  return value;
}
